import { Route, Routes } from "react-router-dom";
import AppThemeTestA from "./AppThemeTest/AppThemeTestA";
import AppThemeTestB from "./AppThemeTest/AppThemeTestB";
import CategoryLandingPage from "./Category/CategoryLandingPage";
import LpAiRecommendation from "./Sleep/LpAiRecommendation";
import LpSoundMix from "./Sleep/LpSoundMix";
import LpSubscription from "./Sleep/LpSubscription";
import LpSubscriptionBenefit from "./Sleep/LpSubscriptionBenefit";
import LpVideo from "./Sleep/LpVideo";
import TestResult from "./shared/TestResult";

export default function LandingRoot() {
  const APP_THEME_TEST_PREFIX = 'theme'
  const CATEGORY_PREFIX = 'category'
  const SLEEP_PREFIX = 'sleep'
  const SHARED_PREFIX = 'shared'
  return (
    <Routes>
      <Route path={`${APP_THEME_TEST_PREFIX}/basic`} element={<AppThemeTestA/>}/>
      <Route path={`${APP_THEME_TEST_PREFIX}/brain`} element={<AppThemeTestB/>}/>
      <Route path={`${CATEGORY_PREFIX}/:type`} element={<CategoryLandingPage/>}/>
      <Route path={`${SLEEP_PREFIX}/ai-recommendation`} element={<LpAiRecommendation/>}/>
      <Route path={`${SLEEP_PREFIX}/subscription`} element={<LpSubscription/>}/>
      <Route path={`${SLEEP_PREFIX}/subscription-benefit`} element={<LpSubscriptionBenefit/>}/>
      <Route path={`${SLEEP_PREFIX}/video`} element={<LpVideo/>}/>
      <Route path={`${SLEEP_PREFIX}/sound-mix`} element={<LpSoundMix/>}/>
      <Route path={`${SHARED_PREFIX}/test/result`} element={<TestResult/>}/>
    </Routes>
  )
}
